// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iOwm","content":"styles_content__1Tkcv","row":"styles_row__3YIxw","footer":"styles_footer__2BHb3","phraseLength":"styles_phraseLength__1ShG5"};